<template>
  <div>
    <MbSearch @goReload="goReload" ref="info"></MbSearch>
    <section id="con">
      <MbWhrSearch />
      <div class="mcn mcon04">
        <div class="left_tbl">
          <div class="mtbl">
            <table>
              <colgroup>
                <col width="45%" />
                <col width="55%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">종목코드</th>
                  <th scope="col">종목명</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in searchPages.items" :key="index">
                  <td class="ta_c">
                    <a @click="goMbNWPage(item.kwSymbol, media)">{{ item.symbol }}</a>
                  </td>
                  <td>
                    <span>{{ item.kwName }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="right_tbl">
          <div class="mtbl">
            <table>
              <colgroup>
                <col width="70" />
                <col width="85" />
                <col width="*" />
                <col width="85" />
                <col width="85" />
                <col width="85" />
              </colgroup>
              <thead :class="{ postic: isEmpty }">
                <tr>
                  <th scope="col" rowspan="2">FY1</th>
                  <th scope="col" rowspan="2">
                    투자의견<img
                      src="https://img.thinkpool.com/concert/us/kiwoom/usRecode/img/tbl_wm.jpg"
                      alt="안내"
                      class="inv"
                      width="15"
                      @click="openMemo"
                    />
                  </th>
                  <th scope="col" rowspan="2">EPS 예측치</th>
                  <th scope="col" colspan="3">수익률(%)</th>
                </tr>
                <tr>
                  <th scope="col">1주</th>
                  <th scope="col">1개월</th>
                  <th scope="col">3개월</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in searchPages.items" :key="index">
                  <td class="ta_c">{{ item.fy1 }}</td>
                  <td class="ta_r">{{ item.recome }}</td>
                  <td class="ta_r">{{ item.eps }}</td>
                  <template v-if="item.tvo !== null">
                    <td class="ta_r">{{ item.tvo.weekRate }}</td>
                    <td class="ta_r">{{ item.tvo.rate1m }}</td>
                    <td class="ta_r lst">{{ item.tvo.rate3m }}</td>
                  </template>
                  <template v-else>
                    <td class="ta_r">-</td>
                    <td class="ta_r">-</td>
                    <td class="ta_r lst">-</td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="more" v-if="'Y' === searchPages.nextPgFlag">
          <a @click="goPage(searchPages.pageNo + 1)">더보기</a>
        </div>
        <div class="p_inv_w">
          <div class="p_inv">
            <div class="con">Analysts' recommendation(1=Buy 5=Sell)</div>
            <div class="btn">
              <a href="javascript:;" @click="closeMemo">닫 기</a>
            </div>
          </div>
        </div>
      </div>
      <MbBottomInfo />
    </section>
  </div>
</template>

<script>
import MbWhrSearch from '@/components/kiwoom/usRecord/mb/common/WhrSearch'
import MbSearch from '@/components/kiwoom/usRecord/mb/common/Search'
import MbBottomInfo from '@/components/kiwoom/usRecord/mb/common/BottomInfo'
import { mapGetters } from 'vuex'
import axios from 'axios'
import commonMixin from '@/mixin/commonMixin.js'

export default {
  mixins: [commonMixin],
  components: {
    MbWhrSearch,
    MbSearch,
    MbBottomInfo
  },
  data () {
    return {
      searchPages: {
        pageNo: 1,
        pageSize: 10,
        totalRows: 0,
        nextPgFlag: 'N',
        items: []
      },
      isFixed: false
    }
  },
  methods: {
    setSearchPagesDataInit () {
      this.searchPages.items.splice(0)
      this.searchPages.pageNo = 1
      this.searchPages.totalRows = 0
      this.searchPages.nextPgFlag = 'N'
      this.searchPages.items = []
    },
    init () {
      const params = {
        pageNo: this.searchPages.pageNo,
        pageSize: this.searchPages.pageSize,
        chkIndex: this.getUsRecordSettings.chkIndex,
        symbol: this.getUsRecordSettings.symbol
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/consensus/getUsStockDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        this.searchPages.totalRows = res.data.resObj.totalRows
        this.searchPages.nextPgFlag = res.data.resObj.nextPgFlag
        let len = 0
        if (res.data.resObj.epsList !== undefined) {
          len = res.data.resObj.epsList.length
        }

        for (var i = 0; i < len; i++) {
          this.searchPages.items.push(res.data.resObj.epsList[i])
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    initMmry () {
      const params = {
        pageNo: this.searchPages.pageNo,
        pageSize: this.searchPages.pageSize,
        chkIndex: this.getUsRecordSettings.chkIndex,
        symbol: this.getUsRecordSettings.symbol
      }
      this.$store.dispatch('setLodingBarSetting', true)

      let postUrl = 'https://security.thinkpool.com/api/us/kw/consensus/getUsStockMainDataListAjax.do'
      axios.post(postUrl, params).then((res) => {
        this.searchPages.totalRows = res.data.resObj.totalRows
        this.searchPages.nextPgFlag = res.data.resObj.nextPgFlag
        let len = 0
        this.searchPages.items = []
        if (res.data.resObj.epsList !== undefined) {
          len = res.data.resObj.epsList.length
        }

        for (var i = 0; i < len; i++) {
          this.searchPages.items.push(res.data.resObj.epsList[i])
        }

        this.$store.dispatch('setLodingBarSetting', false)
      })
    },
    goPage (pageNo) {
      this.searchPages.pageNo = parseInt(pageNo)
      this.init()
    },
    goReload () {
      this.setSearchPagesDataInit()
      this.goPage('1')
    },
    openMemo () {
      $('.p_inv_w').toggle()
    },
    closeMemo () {
      $('.p_inv_w').hide()
    },
    setSymbolDataReset () {
      localStorage.setItem('symbol', '')
      localStorage.setItem('syName', '')
      this.$store.dispatch('saveUsSymbolSetting', '')
      this.$store.dispatch('saveUsSyNameSetting', '')
    }
  },
  created () {
    this.$store.dispatch('initUSdata')
    if (this.getUsRecordSettings.chkIndex !== 'SYMBOL') {
      this.setSymbolDataReset()
    }
    this.initMmry()
  },
  mounted () {
    setTimeout(() => {
      // 수정부분 (오른쪽 테이블 헤더 고정)
      const mc01 = document.querySelector('.mcon04')
      const mc01Top = mc01.offsetTop - 34
      const rightTblH = document.querySelector('.right_tbl thead')
      const rightTbl = document.querySelector('.right_tbl')
      const leftTblWidth = document.querySelector('.left_tbl').offsetWidth

      document.addEventListener('scroll', () => {
        // 현재 스크롤 위치를 계산
        const scrollPosition =
          window.scrollY || document.documentElement.scrollTop

        // 스크롤 위치가 rTableTop에 도달했는지 확인
        if (scrollPosition >= mc01Top) {
          rightTblH.classList.add('fixed-header')
          rightTblH.style.left = leftTblWidth + 'px'
          this.isFixed = true
        } else {
          rightTblH.classList.remove('fixed-header')
          rightTblH.style.left = 'auto'
          this.isFixed = false
        }

        if (this.isFixed) {
          rightTblH.style.left = leftTblWidth - rightTbl.scrollLeft + 'px'
        }
      })

      rightTbl.addEventListener('scroll', () => {
        // rightTbl이 고정 상태인 경우에만 left 위치를 조정
        if (this.isFixed) {
          rightTblH.style.left = `${leftTblWidth - rightTbl.scrollLeft}px`
        }
      })
    }, 500)
  },
  computed: {
    ...mapGetters(['getUsRecordSettings']),
    getChkIndex () {
      return this.getUsRecordSettings.chkIndex
    },
    getSymbol () {
      return this.getUsRecordSettings.symbol
    },
    isEmpty () {
      if (this.searchPages.items && this.searchPages.items.length <= 0) {
        return true
      }
      return false
    }
  },
  watch: {
    getChkIndex (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('chkIndex', val)
        this.setSearchPagesDataInit()
        var chkIndexChg = this.getUsRecordSettings.chkIndexChg
        if (val !== 'SYMBOL' && chkIndexChg) {
          this.$store.dispatch('saveUsSymChgFlagSetting', 'N')
          this.setSymbolDataReset()
          this.goPage('1')
        } /* else {
          if (this.getUsRecordSettings.symChgFlag === 'Y') {
            this.init()
          }
        } */
      }
    },
    getSymbol (val, oldVal) {
      if (val !== oldVal) {
        localStorage.setItem('symbol', val)
        if (val) {
          this.goPage('1')
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/kiwoom/usRecord/mb/Drecord.vue